var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", [
        _c(
          "div",
          [
            _c(
              "b-row",
              { staticClass: "temp_mapping" },
              [
                _c("b-col", { attrs: { md: "8" } }, [
                  _c("h4", [_vm._v(_vm._s(_vm.$t("Mappings")))])
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { md: "4" } }, [
                  _c(
                    "div",
                    { staticClass: "float-right add-field-btn" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.externalService",
                              modifiers: { externalService: true }
                            }
                          ],
                          staticClass: "mt-0",
                          attrs: {
                            type: "submit",
                            size: "sm",
                            variant: "secondary"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Add new mapping")) + " "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.importMappings",
                              modifiers: { importMappings: true }
                            }
                          ],
                          staticClass: "mt-0",
                          attrs: {
                            type: "submit",
                            size: "sm",
                            variant: "secondary"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-upload" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CONFIGURED.IMPORT_MAPPINGS")) +
                                " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("b-card", [
        _c(
          "div",
          [
            _c(
              "b-row",
              { staticClass: "temp_mapping" },
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { md: "5" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ACCOUNT.CURRENT_SALESFORCE_ORG")) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { md: "7" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.extServiceData.external_service_title
                              ) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { md: "2" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ACCOUNT.CURRENT_SALESFORCE_URL")) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { md: "7" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.extServiceData.external_service_url) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        _vm._l(this.externalServiceMaps, function(map) {
          return _c(
            "b-col",
            { key: map.id, attrs: { cols: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card",
                    { attrs: { "border-variant": "info", align: "left" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { md: "8" } }, [
                                _c("h5", [_vm._v(_vm._s(map.name))])
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { md: "4" } }, [
                                _c(
                                  "div",
                                  { staticClass: "float-right add-field-btn" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          type: "submit",
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.editExternalServiceMap(
                                              map.template_doc_id
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          type: "submit",
                                          size: "sm",
                                          variant: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.showDeleteModal(
                                              map.template_doc_id
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-trash" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "card-text" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Integration Type:")
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "8 text-left" } }, [
                                _vm._v(_vm._s(map.integration_type))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Connection Type:")
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "8 text-left" } }, [
                                _vm._v(_vm._s(map.connection_type))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("External Url:")
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "8 text-left" } }, [
                                _vm._v(_vm._s(map.external_service_url))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Template:")
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "8 text-left" } }, [
                                _vm._v(_vm._s(map.template))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.demoMode
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Username:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [_vm._v(_vm._s(map.username))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.demoMode
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Password:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [_vm._v(_vm._s(map.password))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.demoMode
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Description:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [_vm._v(_vm._s(map.description))]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "externalServiceModal",
          staticClass: "external-service-modal",
          attrs: {
            id: "externalService",
            size: "lg",
            title: _vm.extServiceData.created ? "New Mapping" : "Edit Mapping",
            "hide-footer": "",
            "header-bg-variant": "light"
          },
          on: { hidden: _vm.onHidingExtSerModal }
        },
        [
          _vm.extServiceData.integration_type
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "2" } }, [
                            _vm._v("Connection Type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "4 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.connectionTypes
                                },
                                on: {
                                  change: _vm.handleSelectedConnectionType
                                },
                                model: {
                                  value: _vm.extServiceData.connection_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "connection_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.connection_type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.extServiceData.connection_type === "Salesforce"
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _vm._v("External Url:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8 text-left" } },
                                        [
                                          _c("b-form-input", {
                                            ref: "fieldKey",
                                            attrs: {
                                              type: "text",
                                              placeholder: "external url",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.extServiceData
                                                  .external_service_url,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.extServiceData,
                                                  "external_service_url",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "extServiceData.external_service_url"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Name:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "external url"
                                    },
                                    model: {
                                      value: _vm.extServiceData.name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Username:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "username"
                                    },
                                    model: {
                                      value: _vm.extServiceData.username,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "username",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.username"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Password:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "password"
                                    },
                                    model: {
                                      value: _vm.extServiceData.password,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "password",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Description:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "description"
                                    },
                                    model: {
                                      value: _vm.extServiceData.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-row"),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "3" } }, [
                                _vm._v("Fields:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "9 text-left" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      plain: true,
                                      options: _vm.extConnection.extFields
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.extServiceData.connection_type === "Salesforce"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _vm._v("Integration type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "8 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.integrationTypes
                                },
                                on: {
                                  change: _vm.handleSelectedIntegrationType
                                },
                                model: {
                                  value: _vm.extServiceData.integration_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "integration_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.integration_type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _vm._v("Process Type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "8 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.processTypes
                                },
                                on: { change: _vm.handleSelectedProcessType },
                                model: {
                                  value: _vm.extServiceData.process_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "process_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.process_type"
                                }
                              }),
                              _vm._v(" "),
                              _vm.extServiceData.process_type == null
                                ? _c("div", { staticStyle: { color: "red" } }, [
                                    _vm._v("Please select Process Type.")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showTemplateRow
                    ? _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Select Template:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      plain: true,
                                      options: _vm.availableTemplateDocs
                                    },
                                    on: { change: _vm.handleSelectedTemplate },
                                    model: {
                                      value:
                                        _vm.templateDoc.selectedTemplateDocId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateDoc,
                                          "selectedTemplateDocId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "templateDoc.selectedTemplateDocId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c("b-row"),
          _vm._v(" "),
          _vm.extServiceData.process_type != null
            ? _c(
                "div",
                [
                  _c("b-row"),
                  _vm._v(" "),
                  _vm.showVersionsRow
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Select Page:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          cols: "8",
                                          plain: true,
                                          options: _vm.availableTemplates
                                        },
                                        on: {
                                          change: _vm.fetchTemplateVersion
                                        },
                                        model: {
                                          value: _vm.selectedTemplate,
                                          callback: function($$v) {
                                            _vm.selectedTemplate = $$v
                                          },
                                          expression: "selectedTemplate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.selectedTemplate == null
                                        ? _c(
                                            "div",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("Please select a page.")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Select Version:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          plain: true,
                                          options: _vm.availableTemplateVersions
                                        },
                                        on: { change: _vm.resetObjectRow },
                                        model: {
                                          value: _vm.selectedTemplateVersion,
                                          callback: function($$v) {
                                            _vm.selectedTemplateVersion = $$v
                                          },
                                          expression: "selectedTemplateVersion"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.selectedTemplateVersion == null
                                        ? _c(
                                            "div",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("Please select a version.")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "4" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4 text-left" } },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "float-right create-button",
                              attrs: {
                                size: "sm",
                                variant: "secondary mr-1",
                                disabled: !_vm.extServiceData.process_type
                              },
                              on: { click: _vm.createMapping }
                            },
                            [_vm._v("Create/Fetch")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { card: "" } },
                        [
                          _c(
                            "b-tab",
                            {
                              staticStyle: { "background-color": "white" },
                              attrs: { title: "Mappings", active: "" }
                            },
                            [
                              _vm.showObjectRow
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [_vm._v("Select Object:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  attrs: { cols: "8 text-left" }
                                                },
                                                [
                                                  _c("model-select", {
                                                    staticClass: "modelSelect",
                                                    attrs: {
                                                      plain: true,
                                                      options:
                                                        _vm.extConnection
                                                          .extObjects,
                                                      placeholder:
                                                        "Select External Object"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.extConnection
                                                          .selectedObj,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.extConnection,
                                                          "selectedObj",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "extConnection.selectedObj"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  !_vm.extConnection.selectedObj
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Please select an object."
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        this.extConnection
                                                          .selectedObj
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showEFM
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-card",
                                            {
                                              attrs: {
                                                "border-variant": "info",
                                                header: "Map Fields",
                                                align: "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "card-text" },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "11 text-left"
                                                          }
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              "External Fields"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("model-select", {
                                                            staticClass:
                                                              "modelSelect",
                                                            attrs: {
                                                              plain: true,
                                                              options:
                                                                _vm
                                                                  .extConnection
                                                                  .extFields,
                                                              placeholder:
                                                                "Select External Field"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .externalServiceMap
                                                                  .selectedExtField,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.externalServiceMap,
                                                                  "selectedExtField",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "externalServiceMap.selectedExtField"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "11 text-left"
                                                          }
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              "Mapping Type"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              plain: true,
                                                              options:
                                                                _vm.mappingTypeOptions
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.mappingType,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.mappingType = $$v
                                                              },
                                                              expression:
                                                                "mappingType"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _vm.mappingType ===
                                                      "TEMPLATE_FIELD"
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols:
                                                                  "11 text-left"
                                                              }
                                                            },
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Template Fields"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "model-select",
                                                                {
                                                                  staticClass:
                                                                    "modelSelect",
                                                                  attrs: {
                                                                    plain: true,
                                                                    options:
                                                                      _vm
                                                                        .templateDoc
                                                                        .tmpFields
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .externalServiceMap
                                                                        .selectedTmpField,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.externalServiceMap,
                                                                        "selectedTmpField",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "externalServiceMap.selectedTmpField"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _vm.mappingType ===
                                                      "DEFAULT"
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols:
                                                                  "11 text-left"
                                                              }
                                                            },
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Default Value"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Enter Default Value"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.defaultValue,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.defaultValue = $$v
                                                                    },
                                                                    expression:
                                                                      "defaultValue"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "11 text-left"
                                                          }
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v("Section")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              plain: true,
                                                              options:
                                                                _vm.sectionsList
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedSection,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selectedSection = $$v
                                                              },
                                                              expression:
                                                                "selectedSection"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.mappingType
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols:
                                                                  "2 text-left"
                                                              }
                                                            },
                                                            [
                                                              _c("label", [
                                                                _vm._v("Action")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-btn",
                                                                {
                                                                  staticStyle: {
                                                                    padding:
                                                                      "1px 10px",
                                                                    "border-radius":
                                                                      "10px"
                                                                  },
                                                                  attrs: {
                                                                    size: "sm",
                                                                    variant:
                                                                      "secondary",
                                                                    disabled:
                                                                      _vm
                                                                        .selectedSection
                                                                        .length <
                                                                      1
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.addFieldMapping
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-plus"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      this.extConnection
                                                        .reqFields.length
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                                padding:
                                                                  "1px 15px"
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "displayReqFields"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      Note: In External fields combo box, " +
                                                                  _vm._s(
                                                                    this
                                                                      .extConnection
                                                                      .reqFields
                                                                      .length
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "COMMON.REQ_FIELD_WARNING"
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !this.extConnection
                                                        .reqFields.length
                                                        ? _c(
                                                            "p",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "displayReqFields"
                                                              }
                                                            },
                                                            [_vm._v(" ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-popover",
                                                        {
                                                          attrs: {
                                                            target:
                                                              "displayReqFields",
                                                            triggers: "hover",
                                                            placement: "left"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                this
                                                                  .extConnection
                                                                  .reqStr
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(
                                            "b-card",
                                            {
                                              attrs: {
                                                "border-variant": "info",
                                                align: "left"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "header" },
                                                  slot: "header"
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticStyle: {
                                                        margin: "0px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "10" } },
                                                        [
                                                          _c(
                                                            "h6",
                                                            {
                                                              staticStyle: {
                                                                margin:
                                                                  "1px 0px 0px 0px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Mapped Fields"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "2" } },
                                                        [
                                                          _c("i", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover",
                                                                modifiers: {
                                                                  hover: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "fa fa-download download-efm fa-lg",
                                                            attrs: {
                                                              title:
                                                                "Download ExternalServiceMappings"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.downloadEsmappings
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.shouldShowDownload
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: { md: "2" }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "float-right"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fa fa-download download-efm",
                                                                    attrs: {
                                                                      title:
                                                                        "Download Mappings"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.downloadESM
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "card-text" },
                                                _vm._l(
                                                  this.sectionsList
                                                    ? this.sectionsList.concat([
                                                        null
                                                      ])
                                                    : [],
                                                  function(section, index) {
                                                    return _c(
                                                      "b-row",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _vm.externalServiceMap.externalFieldMappings.filter(
                                                              function(
                                                                mapping
                                                              ) {
                                                                return (
                                                                  mapping.section ===
                                                                  section
                                                                )
                                                              }
                                                            ).length > 0
                                                              ? _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      section ===
                                                                      null
                                                                        ? " NA "
                                                                        : section
                                                                    ) + " :"
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.externalServiceMap.externalFieldMappings.filter(
                                                                function(
                                                                  mapping
                                                                ) {
                                                                  return (
                                                                    mapping.section ===
                                                                    section
                                                                  )
                                                                }
                                                              ),
                                                              function(map) {
                                                                return _c(
                                                                  "b-row",
                                                                  {
                                                                    key: map.id
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "b-col",
                                                                      {
                                                                        attrs: {
                                                                          sm:
                                                                            "5"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              map.ext_field_api
                                                                            ) +
                                                                            "   ( " +
                                                                            _vm._s(
                                                                              map.ext_field_object
                                                                            ) +
                                                                            " )\n                             \n                          "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-col",
                                                                      {
                                                                        attrs: {
                                                                          sm:
                                                                            "5"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-link"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          "  \n                            " +
                                                                            _vm._s(
                                                                              map.tmp_key &&
                                                                              map.tmp_key !=
                                                                                null &&
                                                                              map.tmp_key !==
                                                                                "null"
                                                                                ? map.tmp_key
                                                                                : " (DEFAULT) " +
                                                                                  map.default_value
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-col",
                                                                      {
                                                                        attrs: {
                                                                          sm:
                                                                            "2"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-trash",
                                                                            staticStyle: {
                                                                              color:
                                                                                "red",
                                                                              cursor:
                                                                                "pointer"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                _vm.deleteExternalFieldMap(
                                                                                  map.id,
                                                                                  map.ext_field_api
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              staticStyle: { "background-color": "white" },
                              attrs: { title: "Sections" }
                            },
                            [
                              _c(
                                "b-card",
                                [
                                  _c("b-card", { staticClass: "multi-card" }, [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { md: "4" } },
                                              [
                                                _c("h5", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CONFIGURED.SECTION_ORDER"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "8" } },
                                              [
                                                _c(
                                                  "span",
                                                  [
                                                    _c("b-form-input", {
                                                      staticStyle: {
                                                        "max-width": "50%",
                                                        display: "inline"
                                                      },
                                                      attrs: {
                                                        size: "md",
                                                        placeholder: _vm.$t(
                                                          "CONFIGURED.ENTER_SECTION_NAME"
                                                        )
                                                      },
                                                      model: {
                                                        value: _vm.sectionName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.sectionName = $$v
                                                        },
                                                        expression:
                                                          "sectionName"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "5px",
                                                          "padding-bottom":
                                                            "0px",
                                                          "border-radius":
                                                            "6px",
                                                          padding:
                                                            "4px 10px 4px 11px"
                                                        },
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "secondary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.addSectionName()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-plus"
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "5px",
                                                          "padding-bottom":
                                                            "0px",
                                                          "border-radius":
                                                            "6px",
                                                          padding:
                                                            "4px 10px 4px 11px"
                                                        },
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "secondary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.updateSectionOrder()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "fa fa-save"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "COMMON.SAVE"
                                                                )
                                                              ) + " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "timeline-div" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "timeline timeline-horizontal"
                                        },
                                        [
                                          _c(
                                            "draggable",
                                            {
                                              staticClass: "flex-container",
                                              attrs: {
                                                options: { group: "sections" }
                                              },
                                              model: {
                                                value: _vm.sectionsList,
                                                callback: function($$v) {
                                                  _vm.sectionsList = $$v
                                                },
                                                expression: "sectionsList"
                                              }
                                            },
                                            _vm._l(_vm.sectionsList, function(
                                              section,
                                              index
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass: "timeline-item"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "timeline-badge bg-primary"
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(index + 1)
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "timeline-panel role-panel"
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(_vm._s(section))
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-trash",
                                                          staticStyle: {
                                                            color: "red",
                                                            cursor: "pointer"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.deleteSectionName(
                                                                section
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            })
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("em", { staticClass: "italic" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CONFIGURED.SECTION_NOTE")
                                        )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "externalServiceImportModal",
          staticClass: "external-service-modal",
          attrs: {
            id: "importMappings",
            size: "lg",
            title: "Import Mappings",
            "hide-footer": "",
            "header-bg-variant": "light"
          },
          on: { hidden: _vm.onHidingExtSerModal }
        },
        [
          _vm.extServiceData.integration_type
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "2" } }, [
                            _vm._v("Connection Type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "4 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.connectionTypes
                                },
                                on: {
                                  change: _vm.handleSelectedConnectionType
                                },
                                model: {
                                  value: _vm.extServiceData.connection_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "connection_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.connection_type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.extServiceData.connection_type === "Salesforce"
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _vm._v("External Url:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8 text-left" } },
                                        [
                                          _c("b-form-input", {
                                            ref: "fieldKey",
                                            attrs: {
                                              type: "text",
                                              placeholder: "external url",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.extServiceData
                                                  .external_service_url,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.extServiceData,
                                                  "external_service_url",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "extServiceData.external_service_url"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Name:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "external url"
                                    },
                                    model: {
                                      value: _vm.extServiceData.name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Username:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "username"
                                    },
                                    model: {
                                      value: _vm.extServiceData.username,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "username",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.username"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Password:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "password"
                                    },
                                    model: {
                                      value: _vm.extServiceData.password,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "password",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Description:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-input", {
                                    ref: "fieldKey",
                                    attrs: {
                                      type: "text",
                                      placeholder: "description"
                                    },
                                    model: {
                                      value: _vm.extServiceData.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.extServiceData,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "extServiceData.description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-row"),
                      _vm._v(" "),
                      !_vm.demoMode
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "3" } }, [
                                _vm._v("Fields:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "9 text-left" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      plain: true,
                                      options: _vm.extConnection.extFields
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.extServiceData.connection_type === "Salesforce"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _vm._v("Integration type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "8 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.integrationTypes
                                },
                                on: {
                                  change: _vm.handleSelectedIntegrationType
                                },
                                model: {
                                  value: _vm.extServiceData.integration_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "integration_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.integration_type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _vm._v("Process Type:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "8 text-left" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.processTypes
                                },
                                on: { change: _vm.handleSelectedProcessType },
                                model: {
                                  value: _vm.extServiceData.process_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.extServiceData,
                                      "process_type",
                                      $$v
                                    )
                                  },
                                  expression: "extServiceData.process_type"
                                }
                              }),
                              _vm._v(" "),
                              _vm.extServiceData.process_type == null
                                ? _c("div", { staticStyle: { color: "red" } }, [
                                    _vm._v("Please select Process Type.")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showTemplateRow
                    ? _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm._v("Select Template:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8 text-left" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      plain: true,
                                      options: _vm.availableTemplateDocs
                                    },
                                    on: { change: _vm.handleSelectedTemplate },
                                    model: {
                                      value:
                                        _vm.templateDoc.selectedTemplateDocId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.templateDoc,
                                          "selectedTemplateDocId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "templateDoc.selectedTemplateDocId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c("b-row"),
          _vm._v(" "),
          _vm.extServiceData.process_type != null
            ? _c(
                "div",
                [
                  _c("b-row"),
                  _vm._v(" "),
                  _vm.showVersionsRow
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Select Page:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          cols: "8",
                                          plain: true,
                                          options: _vm.availableTemplates
                                        },
                                        on: {
                                          change: _vm.fetchTemplateVersion
                                        },
                                        model: {
                                          value: _vm.selectedTemplate,
                                          callback: function($$v) {
                                            _vm.selectedTemplate = $$v
                                          },
                                          expression: "selectedTemplate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.selectedTemplate == null
                                        ? _c(
                                            "div",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("Please select a page.")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Select Version:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          plain: true,
                                          options: _vm.availableTemplateVersions
                                        },
                                        on: { change: _vm.resetObjectRow },
                                        model: {
                                          value: _vm.selectedTemplateVersion,
                                          callback: function($$v) {
                                            _vm.selectedTemplateVersion = $$v
                                          },
                                          expression: "selectedTemplateVersion"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.selectedTemplateVersion == null
                                        ? _c(
                                            "div",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("Please select a version.")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Select File:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "8 text-left" } },
                                    [
                                      _c("input", {
                                        ref: "file",
                                        attrs: {
                                          id: "fileUpload",
                                          type: "file"
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.handleFileUpload()
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "3" } }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                size: "sm",
                                variant: "secondary",
                                disabled: !_vm.isFileSelected
                              },
                              on: { click: _vm.saveImportMappings }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("CONFIGURED.CREATE")) + " "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              attrs: { size: "sm", variant: "light" },
                              on: { click: _vm.hideImportModal }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteModal",
          attrs: {
            centered: "",
            id: "deleteModal",
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "ok-title": _vm.$t("COMMON.DELETE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { cancel: _vm.cancel, ok: _vm.deleteExternalServiceMap },
          nativeOn: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key)
              ) {
                return null
              }
              _vm.deleteExternalServiceMap($event)
            }
          }
        },
        [
          _c("div", { staticClass: "delete-warning" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("COMMON.DEL_SERVICEMAPPING")))])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbaf6876", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbaf6876","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/externalServiceMaps.vue
// module id = 1347
// module chunks = 2